import React from 'react';
import { RouteProps, Redirect } from "react-router-dom";
import { useUserContext } from '../contexts/UserContext';
import PrivateRoute from './PrivateRoute';

export const UserRoute: React.FC<RouteProps> = ({
  component: Component,
  children,
  ...rest
}: any) => {
  const { isUser, isLoadingUser } = useUserContext();

  if (!isLoadingUser && !isUser) {
    return <Redirect to="/" />;
  }

  return (
    <PrivateRoute {...rest} component={Component}>
      {children}
    </PrivateRoute>
  );
};
